<template>
  <div>
    <ul>
      <li v-for="item in transcript" :key="item.text" class="p-4 rounded-lg border border-gray-200 mb-2">
        <strong class="block text-gray-700">{{ item.speaker }}</strong>
        <p class="text-gray-500 mt-1">{{ item.text }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import { chunk } from 'lodash';

export default {
  props: {
    transcriptString: {
      type: String,
      required: true,
    },
  },
  computed: {
    transcript() {
      const items = this.transcriptString.split(/(Speaker\s\d)\:/).filter(x => x !== '\n');

      const chunks = chunk(items, 2);

      return chunks.map(chunk => {
        return {
          speaker: chunk[0].trim(),
          text: chunk[1].split(/\n/).join(' ').trim(),
        };
      });
    },
  },
};
</script>
